<template>
    <div class="content-container">
        <div class="content">
            <div class="container">
                <div class="row">

                    <!-- Title -->
                    <div class="col-12">
                        <div class="title">
                            <h1>{{ pageTitle }}</h1>
                        </div>
                    </div>

                    <!-- Options -->
                    <div class="col-12">
                        <div class="card-grid grid-col-sm-2 row">
                            <div class="selectable-card"
                                 @click="setWarrantyState(false)"
                                 :class="{'active': inWarrantyStatus === false}">
                                <div class="card-body py-4">
                                    <div class="card-img mb-4">
                                        <img src="https://wefix-files.s3.eu-west-2.amazonaws.com/images/icons/general/user-damaged.svg" alt="User Damaged">
                                    </div>
                                    <h6><strong>User damaged</strong></h6>
                                    <p class="text-sm">
                                        A user damaged device is one that has suffered accidental damage such as being dropped.
                                    </p>
                                </div>
                            </div>
                            <div class="selectable-card"
                                 @click="faultySelected"
                                 :class="{'active': inWarrantyStatus === true}">
                                <div class="card-body py-4">
                                    <div class="card-img mb-4">
                                        <img src="https://wefix-files.s3.eu-west-2.amazonaws.com/images/icons/general/device-faulty.svg" alt="Faulty">
                                    </div>
                                    <h6><strong>Faulty</strong></h6>
                                    <p class="text-sm">
                                        A faulty device is one that is no longer fully operational, for no apparent reason.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                <!-- Modal when a user tries to book an in-warranty device when another device exists on order -->
                <max-devices-in-basket-modal></max-devices-in-basket-modal>
            </div>
            <!-- Footer -->
            <footer class="footer fixed-footer">
                <div class="container">
                    <router-link :to="{ name: 'deviceColour'}" class="btn btn-outline-secondary back-btn btn-lg"><i class="fa fa-chevron-left text-sm mr-3"></i> Back</router-link>
                    <button @click="confirmWarrantyState()" :disabled="inWarrantyStatus === null" class="btn btn-lg continue-btn icon-right ml-auto">Next <i class="fa fa-chevron-right ml-3 text-sm"></i></button>
                </div>
            </footer>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";

    export default {
        mounted() {
            if (!this.allowInWarranty) {
                this.setWarrantyState(false);
                this.confirmWarrantyState();
            }
            this.checkCanBeOnPage();
        },

        computed: {
            ...mapGetters([
                'allowInWarranty',
                'allowsInsuranceOrder',
                'devicesInCart',
                'inWarrantyStatus',
                'isBookingInStore',
                'modelVersionHasBeenSelected'
            ]),

            nextStep() {
                if (this.inWarrantyStatus) {
                    return "deviceWarrantyStatus";
                }
                return (this.allowsInsuranceOrder) ? "deviceInsuranceStatus" : "repairSelect";
            },

            pageTitle() {
                if (this.isBookingInStore) {
                    return "Which applies to the device?";
                }

                return "Which applies to your device?";
            }
        },

        methods: {
            ...mapActions(['checkBookingIsComplete', 'setWarrantyState', 'setWarrantyDetails']),

            checkCanBeOnPage() {
                this.checkBookingIsComplete().then(() => {
                    if (!this.modelVersionHasBeenSelected) {
                        this.$router.push({name: 'deviceColour'});
                    }
                });
            },

            confirmWarrantyState() {
                this.$router.push({name: this.nextStep });
            },

            faultySelected() {
                if (this.devicesInCart > 1) {
                    return this.$bvModal.show("max-devices-in-basket-modal");
                }

                return this.setWarrantyState(true);
            }
        }
    }
</script>

<style scoped>

</style>